export default "__VITE_ASSET__Bn1soN$x__"